import React, { useState } from 'react';
import TemplatesPage from './TemplatesPage';
import QuestionnaireBuilder from './QuestionnaireBuilder';

function QuestionnairesPage({
  sections,
  setSections,
  preview,
  event,
  onBack,
  activeTab,
  setActiveTab
}) {
  return (
    <div className="questionnaires-workspace">
      <nav className="workspace-tabs" aria-label="Questionnaire tools">
        <button
          type="button"
          className={activeTab === 'templates' ? 'active' : ''}
          onClick={() => setActiveTab('templates')}
        >
          Templates
        </button>
        <button
          type="button"
          className={activeTab === 'builder' ? 'active' : ''}
          onClick={() => setActiveTab('builder')}
        >
          Builder
        </button>
      </nav>
      {activeTab === 'templates' ? (
        <TemplatesPage />
      ) : (
        <QuestionnaireBuilder
          sections={sections}
          setSections={setSections}
          preview={preview}
          onBack={onBack}
          eventName={event?.name}
          event={event}
        />
      )}
    </div>
  );
}

export default QuestionnairesPage;